import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { mapDto } from '@shared/operators';
import { Module, ModuleDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getModule(id: string): Observable<Module> {
        return this.httpClient.get<ModuleDto>(`library/modules/${id}`).pipe(
            mapDto((response) => new Module(response)),
            catchError((error: HttpErrorResponse) => {
                if (error.status === 403) {
                    throw new Error('no-access');
                }
                throw error;
            }),
        );
    }
}
